import { Injectable } from "@angular/core";
import { ValidatorFn } from "@angular/forms";
import {
  CascaderOption,
  CheckboxOption,
  InputNumber,
  RadioOption,
  SelectOption,
} from "../model/common-type";

// 控件列表
export class FormItem {
  type: FormListType;
  label: string; // 文本
  name: string; // 字段名称
  require?: boolean = false; // 是否必填
  placeholder?: string; // 输入框提示文案
  width?: number = 1; // 占据的列数。默认1
  hide?: boolean = false; // 是否为隐藏字段，仅用于填充表单的字段，不显示在页面上
  /**
   * 是否允许清空当前控件（Input 清空按钮、Select/Date/Cascader 等清空图标）。
   * 不传默认 true；Select 未配此项时仍可回退到 selectOption.hdAllowClear
   */
  hdAllowClear?: boolean;
  totalWidth?: number = 0;
  isRowFirst?: number = 0; // 是否是一行的第一个元素
  columnItems?: Array<any>; // 当前行的所有列的items
  value?:
    | string
    | boolean
    | number
    | Date
    | Array<string | number | boolean | Date>
    | null = null; // 值 不传默认为null
  disabled?: boolean;
  color?: string;
  // 组件内部成员
  maxLength?: number; // input控件的输入长度
  prefix?: string; // input前缀文字，对应 nz-input-group nzPrefix
  prefixIcon?: string; // input前缀图标，对应 nz-icon nzType
  selectOption?: SelectOption; // 控件为Select时，选项列表
  radioOption?: RadioOption; // 控件为Radio时，选项列表
  checkboxOption?: CheckboxOption; // 控件为Checkbox组时，选项列表
  inputNumber?: InputNumber = new InputNumber(); // number组件的min、max、step
  onChangeEvent?: Function; // 控件的值改变事件 可用于控件间联动
  onSearchEvent?: Function; // select选择器搜索事件 可用于更新备选集合
  onOpenChangeEvent?: Function; // select下拉展开/收起；展开时组件先清空 selectList 再回调，可用于按需请求
  defaultLabel?: string | Array<string>; // select选择器不初始化的时候可以使用defaultLabel搭配value，设置默认值
  hdDisabledDate?: Function; // date-picker组件不可选择的日期
  hdShowToday?: boolean = true; // 对应 nzShowToday，是否显示「今天」按钮，默认 true
  explain?: string; // label底部的介绍
  textAreaRows?: number; // textArea的行数
  showTime?: boolean = false; // 日期选择器是否包含时间
  labelColor?: string; // label的文字的颜色
  validatorKeys?: Array<ValidatorKey>;
  validator?: ValidatorFn;
  onChangeEventDebounceTime?: number; // change事件防抖，未配置或为0时同步触发（不防抖）
  onSearchEventEventDebounceTime?: number; // search事件防抖，未配置或为0时同步触发（不防抖）
  onOpenChangeEventDebounceTime?: number; // 下拉展开事件防抖，未配置或为0时同步触发（不防抖）
  cascaderOption?: CascaderOption; // 级联选择器配置
  format?: string; // 时间的格式化规则
  /** RegionAddress：详细地址字段名（与 name 组成两个 FormControl） */
  addressName?: string;
  /** RegionAddress：详细地址初始值 */
  addressValue?: string;
  /** RegionAddress：详细地址占位符，默认「请输入详细地址」 */
  addressPlaceholder?: string;
  /** RegionAddress：详细地址最大长度 */
  addressMaxLength?: number;
}

export class ValidatorKey {
  key: string;
  label: string;
}

// 控件类型
export enum FormListType {
  Input, // 输入框
  Select, // 单项选择器
  Date, // 单个日期选择
  DateRange, // 日期范围选择
  TextArea, // 块级输入框
  InputNumber, // 数字输入
  MultipleSelect, // 多选
  ViewDom, // 单纯的显示控件
  Switch, // 开关
  Time, // 时间选择器
  Cascader, // 级联选择器
  Radio, // 单选
  Checkbox, // 复选框
  RegionAddress, // 省市区级联 + 详细地址（占 2 列，注册两个 FormControl）
}

@Injectable({
  providedIn: "root",
})
export class HdFormService {
  constructor() {}
}
